import React, { Component } from 'react';
import { Typography, Divider, Grid, CardContent, Container } from '@material-ui/core';
import { Card } from 'react-bootstrap';
import { GetData } from '../api/service';
import BreadCrumbOwn from '../component/Essentials/BreadCrumbOwn';


class DepertmentContainer extends Component {
    state = {
        departments: [],
       
    }

    componentDidMount() {
        this.setState({
            departments: this.props.departments,
          
        })
    }


 

    render() {
        return (
            <div>
              
              
              <Container>
                <Typography variant="h4" style={{ margin: "1em 0" }} gutterBottom>
                  Departments
                </Typography>
              
                <Typography variant="body1" gutterBottom>
                    Choose the department you want to view in details
                </Typography>

                <Divider />
                <br />

                <Grid container spacing={2}>
                    {this.state.departments.map((el, index) => <Grid key={index} item
                        xs={12}
                        sm={12}
                        md={4}
                        lg={4}
                        style={{
                            cursor: 'pointer'
                        }}
                        onClick={() => this.props.history.replace(`/department/${el.dept_code}`)}
                    >
                        <Card border="primary">
                            <CardContent>
                              <div style={{height:'70px'}}>
                                <Typography
                                    variant="subtitle2"
                                    style={{fontWeight: 700, fontSize: 20}}
                                >
                                    {el.dept_name}
                                </Typography>
                                <Typography
                                    variant="caption"
                                    style={{fontWeight: 700, fontSize: 16}}
                                >
                                    {el.dept_name_as}
                                </Typography>
                              </div>
                            </CardContent>
                            
                            {/* {Array.isArray(el.banner) && el.banner.length > 0 && <img style={{width:'100%',height:'190px', }} src={el.banner[0]} alt={el.banner[0]} />} */}
                        </Card>
                    </Grid>)}
                </Grid>
              </Container>
            </div>
        );
    }
}



export default DepertmentContainer;